import { usePwaViewportWidth } from "../../hooks/useScreenWidth";
import { RootContainer } from "../../styles/Container.style";
import { Image } from "../Informations.page";

export default function CynoMethodPage() {
  const viewportWidth = usePwaViewportWidth();

  return (
    <RootContainer $alignItem="center">
      {/* <Title $fontSize={getVpFontSize(viewportWidth, 14)}>THE CYNO METHOD</Title> */}
      <Image $width={viewportWidth + "px"} src="/informations/the-cyno-method.png" />
    </RootContainer>
  );
}
